module.exports = __webpack_public_path__ + "img/mesa_el_p.bc805441.png";